import { render, staticRenderFns } from "./retur-detail-modal.vue?vue&type=template&id=5b544958&"
import script from "./retur-detail-modal.vue?vue&type=script&lang=js&"
export * from "./retur-detail-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports